"use strict";
var assocIndexOf = require('./_assocIndexOf');
function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([key, value]);
    }
    else {
        data[index][1] = value;
    }
    return this;
}
module.exports = listCacheSet;
//# sourceMappingURL=_listCacheSet.js.map